import { z } from 'zod';

/**
 * Wire schemas for cuisine reference API responses (snake_case).
 * Timestamps are ISO DATETIME strings; is_curated is a 0/1 integer;
 * description may be null.
 */
export const cuisineWireSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  description: z.string().nullable().optional(),
  is_curated: z.number().int(),
  created_at: z.string(),
  updated_at: z.string(),
});
export type CuisineWire = z.infer<typeof cuisineWireSchema>;

export const paginatedCuisineResponseSchema = z.object({
  items: z.array(cuisineWireSchema),
  total: z.number().int().min(0),
  page: z.number().int().min(1),
  per_page: z.number().int().min(1).max(100),
  total_pages: z.number().int().min(0),
});
export type PaginatedCuisineResponseWire = z.infer<typeof paginatedCuisineResponseSchema>;
